export default {
  manage_deleteDriverStatus: "Eliminar Estado de Conductor",
  manage_deleteDriverStatusList: "Eliminar Estados de Conductor",
  manage_deletedDriverStatus: "Estado de Conductor eliminado",
  manage_deletedDriverStatusList: "Estados de Conductor eliminado",
  manage_deleteManageDriverStatus_confirmationMessage:
    "¿Está seguro de que desea eliminar los siguientes Estados de Conductor?"
};
